import BaseWidget from 'components/BaseWidget/BaseWidget';
import useLocation from 'hooks/useLocation';
import { useGetCWActiveAlertsQuery } from 'services/alerts/alerts.api';
import {
  FORECAST_ADVISORIES_QUERY_OPTIONS,
  FORECAST_ADVISORIES_ROUTE,
  FORECAST_ADVISORY_MODES,
} from './config/forecastAdvisories.config';
import AlertCreatorWidget from './widgets/AlertCreatorWidget/AlertCreatorWidget';
import AlertListWidget from './widgets/AlertListWidget/AlertListWidget';
import ForecastAdvisoriesWidget from './widgets/ForecastAdvisoriesWidget/ForecastAdvisoriesWidget';

const FORECAST_ADVISORY_WIDGET_TYPES = ['nwsAlerts', 'myForecastAdvisories'];

const WeatherAlertsWidget = ({
  widgetType = 'list',
  dimensions,
  route,
  sidebarOpen,
  isLoading,
  canDeleteAlerts,
}) => {
  const { locations } = useLocation();
  const isForecastAdvisoryWidget = FORECAST_ADVISORY_WIDGET_TYPES.includes(widgetType);
  const {
    data: forecastAdvisoryData,
    error: forecastAdvisoryError,
    isError: hasForecastAdvisoryError,
    isLoading: areForecastAdvisoriesLoading,
    refetch: refetchForecastAdvisories,
  } = useGetCWActiveAlertsQuery(locations.weatherLocation?.coords, {
    ...FORECAST_ADVISORIES_QUERY_OPTIONS,
    skip: !isForecastAdvisoryWidget,
  });
  const forecastAdvisories = Array.isArray(forecastAdvisoryData?.alerts)
    ? forecastAdvisoryData.alerts
    : [];

  return (
    <BaseWidget
      widgetType={widgetType}
      dimensions={dimensions}
      isLoading={isLoading || (isForecastAdvisoryWidget && areForecastAdvisoriesLoading)}
      route={isForecastAdvisoryWidget ? FORECAST_ADVISORIES_ROUTE : null}
      renderers={{
        list: ({ layout, dimensions }) => (
          <AlertListWidget
            layout={layout}
            dimensions={dimensions}
            sidebarOpen={sidebarOpen}
            route={route}
            canDeleteAlerts={canDeleteAlerts}
          />
        ),
        create: ({ layout, dimensions }) => <AlertCreatorWidget layout={layout} />,
        nwsAlerts: () => (
          <ForecastAdvisoriesWidget
            alerts={forecastAdvisories}
            error={forecastAdvisoryError}
            isError={hasForecastAdvisoryError}
            mode={FORECAST_ADVISORY_MODES.all}
            onRetry={refetchForecastAdvisories}
          />
        ),
        myForecastAdvisories: () => (
          <ForecastAdvisoriesWidget
            alerts={forecastAdvisories}
            error={forecastAdvisoryError}
            isError={hasForecastAdvisoryError}
            mode={FORECAST_ADVISORY_MODES.local}
            onRetry={refetchForecastAdvisories}
          />
        ),
      }}
    />
  );
};

export default WeatherAlertsWidget;
